



















import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  name: 'AvatarItem',
  props: {
    userObj: {
      type: Object,
      default: () => {
        return {
          avatar: '',
          nickname: '',
          userId: 0,
          phoneNumber: '',
        };
      },
    },
    marginStr: {
      type: String,
      default: '0px',
    },
    size: {
      type: Number,
      default: 57,
    },
    borderRadiusStr: {
      type: String,
      default: '50%',
    },
  },
});
